// extracted by mini-css-extract-plugin
module.exports = {"form":"_239e93c"};